export default __webpack_public_path__ + "static/media/deutz-fahr-7250-ttv-warrior.45bf90db.jpg";